<template>
  <v-container class="px-0" fluid v-show="innerShouldShow">
    <v-switch v-model="innerValue" v-bind="vProps"></v-switch>
  </v-container>
</template>

<script>
import formMixin from '../formMixin'
export default {
  name: 'TypeSwitch',
  mixins: [formMixin],
  mounted() {
    this.fieldLoaded(); // signal to the form we are loaded
  }
}
</script>
